import { api } from "@/api";

export const getUsersNotLoggedReport =
  async () => {
    return await api.usersNotLoggedReport();
  };
